import { ReactNode } from 'react';
import styles from './collapsed-list.module.scss';

// Mirrors pages/afe-catalog/collapsed-list.tsx: single-line cell renderer for
// a list of items. Renders the first item via `renderItem` and a `+N more`
// suffix when the list has more than one entry. Full list is exposed via the
// native `title` tooltip so hovering reveals every label.
interface CollapsedListProps<T> {
  items: T[];
  getLabel: (item: T) => string;
  renderItem: (item: T) => ReactNode;
  emptyPlaceholder?: ReactNode;
}

export function CollapsedList<T>({
  items,
  getLabel,
  renderItem,
  emptyPlaceholder = '--',
}: CollapsedListProps<T>) {
  if (items.length === 0) return <>{emptyPlaceholder}</>;

  const [first, ...rest] = items;
  const tooltip = items.map(getLabel).join(', ');

  return (
    <span className={styles.collapsedList} title={tooltip}>
      {renderItem(first)}
      {rest.length > 0 && (
        <span className={styles.moreCount}> +{rest.length} more</span>
      )}
    </span>
  );
}
